function getNestedPropBySearchProp(
  ArrayToSearch,
  PropToSearch,
  PropValue,
  prop,
  prop_path
) {
  const data = ArrayToSearch.find(
    (Object) => Object[PropToSearch] === PropValue
  );
  return data && data[prop_path] && data[prop_path][prop]
    ? data[prop_path][prop]
    : "Not Found";
}

module.exports = getNestedPropBySearchProp;
